import React from "react";
import { constCustomerBox } from "../../util/constant";
import { useBox } from "./useBox";
import RefreshIcon from "../../Assets/refresh-icon.png";
import moment from "moment";
import Chart from "react-apexcharts";
import { bulan } from "../../util/constant";
import DeleteIcon from "../../Assets/delete_icon.png";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import CloseLogo from "../../Assets/close_icon.png";
import SearchLogo from "../../Assets/search-icon.png";
import {
  switchDotsAndCommas,
  numberWithCommas,
  hasRole,
} from "../../util/utilFunction";
import "./Box.css";

const Box = () => {
  const {
    dataUser,
    date,
    setDate,
    statusBarang,
    setStatusBarang,
    company,
    setCompany,
    jenisBox,
    setJenisBox,
    jumlah,
    setJumlah,
    keterangan,
    setKeterangan,
    handleKirimBox,
    isError,
    status,
    setStatus,
    setIsRefresh,
    dataTemp,
    subMenu,
    setSubMenu,
    dataTempMonitor,
    dataMerge,
    filterMonth,
    setFilterMonth,
    filterYear,
    setFilterYear,
    produkPick,
    setProdukPick,
    handleReset,
    templateData,
    filterCustomer,
    setFilterCustomer,
    handleExportBox,
    disabledButton,
    setDisabledButton,
    handleDeleteBox,
    popUpDelete,
    setPopUpDelete,
    setPickDataDelete,
    popUpDetail,
    setPopUpDetail,
    pickHistoryBox,
    filterFrom,
    setFilterFrom,
    filterUntil,
    setFilterUntil,
    filterFromUntil,
    sortTanggalBox,
  } = useBox();

  const canDeleteBox = hasRole(
    dataUser,
    "warehouse_admin",
    "super_user",
    "warehouse_gbj_admin"
  );

  // formatDot lokal (dihapus dari import supaya tidak terjadi deklarasi ganda)
  const formatDot = (value) => {
    return value && value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const sum =
    dataTemp &&
    dataTemp.reduce(function (s, a) {
      return s + a.dataWeight;
    }, 0);

  const sumMasuk =
    dataMerge &&
    dataMerge.masuk.reduce(function (s, a) {
      return s + a;
    }, 0);
  const sumKeluar =
    dataMerge &&
    dataMerge.keluar.reduce(function (s, a) {
      return s + a;
    }, 0);

  return (
    <div className="bx-page">
      {/* ================= POPUP HAPUS ================= */}
      {popUpDelete ? (
        <PopUpComponent>
          <div className="bx-modal-head">
            <p className="bx-modal-text">
              Apakah Kamu yakin ingin menghapus Laporan Ini?
            </p>
            <img
              className="bx-close"
              src={CloseLogo}
              onClick={() => {
                setDisabledButton(false);
                setPopUpDelete(false);
                setPickDataDelete();
              }}
              alt="tutup"
            />
          </div>
          <div className="bx-modal-actions">
            <button
              className="bx-btn bx-btn--danger"
              onClick={() => {
                setDisabledButton(true);
                handleDeleteBox();
                setPickDataDelete();
              }}
            >
              Hapus
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}

      {/* ================= POPUP DETAIL HISTORY ================= */}
      {popUpDetail ? (
        <PopUpComponent
          style={{
            width: "80%",
            marginTop: "calc(100vh - 95vh - 20px)",
            height: "90%",
          }}
        >
          <div className="bx-modal-head">
            <div className="bx-modal-filters">
              <div className="bx-field">
                <p className="bx-label">
                  Dari<span className="bx-req">*</span>
                </p>
                <input
                  type="date"
                  className="bx-input"
                  value={filterFrom}
                  onChange={(e) => setFilterFrom(e.target.value)}
                />
              </div>
              <div className="bx-field">
                <p className="bx-label">
                  Sampai<span className="bx-req">*</span>
                </p>
                <input
                  type="date"
                  className="bx-input"
                  value={filterUntil}
                  onChange={(e) => setFilterUntil(e.target.value)}
                />
              </div>
              <button
                className="bx-btn"
                disabled={disabledButton}
                onClick={() => filterFromUntil()}
              >
                Kirim
              </button>
            </div>
            <img
              className="bx-close"
              src={CloseLogo}
              onClick={() => setPopUpDetail(false)}
              alt="tutup"
            />
          </div>

          <div className="bx-table-wrap bx-modal-scroll">
            <table className="bx-table">
              <thead>
                <tr>
                  <th className="bx-th" style={{ width: "5%" }}>
                    No
                  </th>
                  <th className="bx-th">Cust</th>
                  <th className="bx-th">Tanggal</th>
                  <th className="bx-th">Part Name</th>
                  <th className="bx-th">Keluar</th>
                  <th className="bx-th">Masuk</th>
                  <th className="bx-th">Sisa</th>
                  <th className="bx-th">Keterangan</th>
                </tr>
              </thead>
              <tbody>
                {sortTanggalBox &&
                  sortTanggalBox.map((e, index) => (
                    <tr key={index}>
                      <td className="bx-td">{index + 1}</td>
                      <td className="bx-td">{e && e.company}</td>
                      <td className="bx-td">
                        {e && moment(e.date).format("DD-MM-YY")}
                      </td>
                      <td className="bx-td">{e && e.material}</td>
                      <td className="bx-td bx-out bx-num">
                        {e && e.statusBahan === "Keluar"
                          ? formatDot(
                              switchDotsAndCommas(
                                numberWithCommas(e && e.dataWeight)
                              )
                            )
                          : ""}
                      </td>
                      <td className="bx-td bx-in bx-num">
                        {e && e.statusBahan === "Masuk"
                          ? formatDot(
                              switchDotsAndCommas(
                                numberWithCommas(e && e.dataWeight)
                              )
                            )
                          : ""}
                      </td>
                      <td className="bx-td">SISA</td>
                      <td className="bx-td">{e && e.keterangan}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}

      {/* ================= HEADER ================= */}
      <h1 className="bx-title">INPUT PENGGUNAAN BOX</h1>
      <div className="bx-tabs">
        <p
          className={`bx-tab ${subMenu === "Input" ? "bx-tab--active" : ""}`}
          onClick={() => setSubMenu("Input")}
        >
          Input
        </p>
        <p
          className={`bx-tab ${subMenu === "Monitor" ? "bx-tab--active" : ""}`}
          onClick={() => setSubMenu("Monitor")}
        >
          Monitor
        </p>
      </div>

      {subMenu === "Input" ? (
        <>
          {/* ============ FORM INPUT ============ */}
          <div className="bx-card">
            <p className="bx-card-title">Form Penggunaan Box</p>
            {isError ? (
              <p className="bx-error">Mohon Mengisi Semua Kolom berbintang!</p>
            ) : (
              ""
            )}
            <div className="bx-form-grid">
              <div className="bx-field">
                <p className="bx-label">Pilih Tanggal</p>
                <input
                  type="date"
                  className="bx-input"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>

              <div className="bx-field">
                <p className="bx-label">
                  Keluar / Masuk<span className="bx-req">*</span>
                </p>
                <div className="bx-radio-group">
                  <div
                    onClick={() => setStatusBarang("Keluar")}
                    className={`bx-radio ${
                      statusBarang === "Keluar" ? "bx-radio--active" : ""
                    }`}
                  >
                    <input
                      type="radio"
                      value="Keluar"
                      checked={statusBarang === "Keluar"}
                      readOnly
                    />
                    <label>Keluar</label>
                  </div>
                  <div
                    onClick={() => setStatusBarang("Masuk")}
                    className={`bx-radio ${
                      statusBarang === "Masuk" ? "bx-radio--active" : ""
                    }`}
                  >
                    <input
                      type="radio"
                      value="Masuk"
                      checked={statusBarang === "Masuk"}
                      readOnly
                    />
                    <label>Masuk</label>
                  </div>
                </div>
              </div>

              <div className="bx-field">
                <p className="bx-label">
                  Customer<span className="bx-req">*</span>
                </p>
                <select
                  className="bx-select"
                  defaultValue="Customer"
                  onChange={(e) => setCompany(e.target.value)}
                >
                  <option selected={company === ""} disabled>
                    Customer
                  </option>
                  {constCustomerBox.map((data, i) => (
                    <option value={data} key={i} selected={company === data}>
                      {data}
                    </option>
                  ))}
                </select>
              </div>

              <div className="bx-field bx-field--wide">
                <p className="bx-label">
                  Jenis Box<span className="bx-req">*</span>
                </p>
                <select
                  className="bx-select"
                  defaultValue="Jenis Box"
                  onChange={(e) => setJenisBox(e.target.value)}
                >
                  <option selected={jenisBox === ""} disabled>
                    Jenis Box
                  </option>
                  <option value="1">RABBIT 2166, 2266 BIRU (BESAR)</option>
                  <option value="2">
                    Rabbit 3033, 6044, 6033 BIRU (KECIL)
                  </option>
                  {dataUser.tim === 2 ? (
                    <>
                      <option value="3">RABBIT 2166, 2266 HIJAU (BESAR)</option>
                      <option value="4">
                        Rabbit 3033, 6044, 6033 HIJAU (KECIL)
                      </option>
                      <option value="5">Pallet Plastik (GS)</option>
                      <option value="6">Pallet Plastik Kayu (YBI)</option>
                      <option value="7">PALLET KAYU</option>
                      <option value="8">Pallet Plastik</option>
                      <option value="9">DUS</option>
                    </>
                  ) : (
                    ""
                  )}
                </select>
              </div>

              <div className="bx-field">
                <p className="bx-label">
                  Jumlah (Pcs)<span className="bx-req">*</span>
                </p>
                <input
                  type="number"
                  className="bx-input"
                  placeholder="Jumlah Box (Pcs)"
                  value={jumlah ? jumlah : ""}
                  onChange={(e) => setJumlah(e.target.value)}
                  onWheel={(e) => e.target.blur()}
                />
              </div>

              <div className="bx-field bx-field--wide">
                <p className="bx-label">Keterangan</p>
                <textarea
                  className="bx-textarea"
                  placeholder="Masukkan Keterangan Jika Diperlukan"
                  value={keterangan}
                  onChange={(e) => setKeterangan(e.target.value.toUpperCase())}
                />
              </div>
            </div>

            <div className="bx-form-actions">
              <button
                className="bx-btn"
                disabled={disabledButton}
                onClick={() => {
                  setDisabledButton(true);
                  handleKirimBox();
                }}
              >
                Kirim
              </button>
            </div>
          </div>

          {/* ============ DAFTAR HARIAN ============ */}
          <div className="bx-card">
            <p className="bx-card-title">Daftar Penggunaan Box</p>
            <div className="bx-filters">
              <div className="bx-field">
                <p className="bx-label">Pilih Tanggal</p>
                <input
                  type="date"
                  className="bx-input"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>
              <div className="bx-field">
                <p className="bx-label">Status</p>
                <select
                  defaultValue="Status"
                  onChange={(e) => setStatus(e.target.value)}
                  className="bx-select"
                  value={status}
                >
                  <option selected disabled>
                    Status
                  </option>
                  <option value="Masuk">Masuk</option>
                  <option value="Keluar">Keluar</option>
                </select>
              </div>
              <button
                className="bx-btn bx-btn--ghost"
                onClick={() => setStatus("Status")}
              >
                Reset
              </button>
              <img
                src={RefreshIcon}
                alt="refresh"
                className="bx-icon-btn"
                onClick={() => setIsRefresh(true)}
              />
            </div>

            <div className="bx-table-wrap">
              <table className="bx-table">
                <thead>
                  <tr>
                    <th className="bx-th">No</th>
                    <th className="bx-th">Cust</th>
                    <th className="bx-th">Jenis Box</th>
                    <th className="bx-th">Jumlah (Pcs)</th>
                    <th className="bx-th">Status</th>
                    <th className="bx-th">Update By</th>
                    <th className="bx-th">
                      Jam
                      <br /> Masuk / Keluar
                    </th>
                    <th className="bx-th">Keterangan</th>
                    {canDeleteBox ? <th className="bx-th"></th> : ""}
                  </tr>
                </thead>
                <tbody>
                  {dataTemp &&
                    dataTemp.map((e, index) => (
                      <tr key={index}>
                        <td className="bx-td">{index + 1}</td>
                        <td className="bx-td">{e && e.company}</td>
                        <td className="bx-td">{e && e.material}</td>
                        <td className="bx-td bx-num">{e && e.dataWeight}</td>
                        <td
                          className={`bx-td ${
                            e && e.statusBahan === "Masuk" ? "bx-in" : "bx-out"
                          }`}
                        >
                          {e && e.statusBahan}
                        </td>
                        <td className="bx-td">
                          {e && e.updatedBy.split(" ").slice(0, 1).join(" ")}
                        </td>
                        <td className="bx-td">
                          {moment(e && e.updateTime).format("HH:mm:ss")}
                        </td>
                        <td className="bx-td">{e && e.keterangan}</td>
                        {canDeleteBox ? (
                          <td className="bx-td">
                            <img
                              className="bx-icon"
                              src={DeleteIcon}
                              alt="hapus"
                              onClick={() => {
                                setPopUpDelete(true);
                                setPickDataDelete(e);
                              }}
                            />
                          </td>
                        ) : (
                          ""
                        )}
                      </tr>
                    ))}
                  <tr className="bx-total-row">
                    <td className="bx-td"></td>
                    <td className="bx-td"></td>
                    <td className="bx-td">JUMLAH</td>
                    <td className="bx-td bx-num">{formatDot(sum && sum)}</td>
                    <td className="bx-td"></td>
                    <td className="bx-td"></td>
                    <td className="bx-td"></td>
                    <td className="bx-td"></td>
                    {canDeleteBox ? <td className="bx-td"></td> : ""}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      ) : (
        <>
          {/* ============ MONITOR ============ */}
          <div className="bx-card">
            <p className="bx-card-title">Stok Box di Customer</p>
            <div className="bx-table-wrap">
              <table className="bx-table">
                <thead>
                  <tr>
                    <th className="bx-th">No</th>
                    <th className="bx-th">Cust</th>
                    <th className="bx-th">Jenis</th>
                    <th className="bx-th">Jumlah di Customer</th>
                    <th className="bx-th">Updated By</th>
                    <th className="bx-th">Update Time</th>
                    <th className="bx-th"></th>
                  </tr>
                </thead>
                <tbody>
                  {dataTempMonitor &&
                    dataTempMonitor.map((e, index) => (
                      <tr key={index}>
                        <td className="bx-td">{index + 1}.</td>
                        <td className="bx-td">{e && e.company}</td>
                        <td className="bx-td">{e && e.material}</td>
                        <td className="bx-td bx-num">
                          {formatDot(e && e.weight)}
                        </td>
                        <td className="bx-td">
                          {e && e.updatedBy.split(" ").slice(0, 2).join(" ")}
                        </td>
                        <td className="bx-td">
                          {e && e.updateTime
                            ? moment(e && e.updateTime)
                                .utcOffset("+0700")
                                .format("DD-MMM-YYYY")
                            : ""}
                        </td>
                        <td className="bx-td">
                          <img
                            className="bx-icon"
                            src={SearchLogo}
                            alt="detail"
                            onClick={() => {
                              setPopUpDetail(true);
                              pickHistoryBox(e);
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* ============ ANALYTICS ============ */}
          <h2 className="bx-section-title">Analytics</h2>
          <div className="bx-card">
            <div className="bx-filters">
              <div className="bx-field" style={{ minWidth: "260px" }}>
                <p className="bx-label">Jenis Box</p>
                <select
                  className="bx-select"
                  defaultValue="Jenis Box"
                  onChange={(e) => setProdukPick(e.target.value)}
                >
                  <option selected={produkPick === ""} disabled>
                    Jenis Box
                  </option>
                  <option value="RABBIT 2166, 2266 BIRU (BESAR)">
                    RABBIT 2166, 2266 BIRU (BESAR)
                  </option>
                  <option value="Rabbit 3033, 6044, 6033 BIRU (KECIL)">
                    Rabbit 3033, 6044, 6033 BIRU (KECIL)
                  </option>
                  {dataUser.tim === 2 ? (
                    <>
                      <option value="RABBIT 2166, 2266 HIJAU (BESAR)">
                        RABBIT 2166, 2266 HIJAU (BESAR)
                      </option>
                      <option value="Rabbit 3033, 6044, 6033 HIJAU (KECIL)">
                        Rabbit 3033, 6044, 6033 HIJAU (KECIL)
                      </option>
                    </>
                  ) : (
                    ""
                  )}
                </select>
              </div>
              <div className="bx-field">
                <p className="bx-label">Customer</p>
                <select
                  defaultValue="Pilih No Mesin"
                  onChange={(e) => setFilterCustomer(e.target.value)}
                  className="bx-select"
                  value={filterCustomer}
                >
                  <option selected disabled>
                    Pilih Customer
                  </option>
                  {constCustomerBox.map((data, i) => (
                    <option
                      value={data}
                      key={i}
                      selected={filterCustomer === data}
                    >
                      {data}
                    </option>
                  ))}
                </select>
              </div>
              <div className="bx-field">
                <p className="bx-label">Bulan</p>
                <select
                  defaultValue="Bulan"
                  onChange={(e) => setFilterMonth(e.target.value)}
                  className="bx-select"
                  value={filterMonth}
                >
                  <option selected disabled>
                    Pilih Bulan
                  </option>
                  {bulan &&
                    bulan.map((data) => (
                      <option value={data.value} key={data.value}>
                        {data.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="bx-field">
                <p className="bx-label">Tahun</p>
                <select
                  defaultValue="Tahun"
                  onChange={(e) => setFilterYear(e.target.value)}
                  className="bx-select bx-select--sm"
                  value={filterYear}
                >
                  <option selected disabled>
                    Pilih Tahun
                  </option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                </select>
              </div>
              <button
                className="bx-btn bx-btn--ghost"
                onClick={() => handleReset()}
              >
                Reset
              </button>
              <button
                className="bx-btn bx-btn--success"
                onClick={() => handleExportBox()}
              >
                Export
              </button>
            </div>

            <div className="bx-stats">
              <div className="bx-stat bx-stat--out">
                <p className="bx-stat-label">Keluar</p>
                <p className="bx-stat-value">{formatDot(sumKeluar)}</p>
              </div>
              <div className="bx-stat bx-stat--in">
                <p className="bx-stat-label">Masuk</p>
                <p className="bx-stat-value">{formatDot(sumMasuk)}</p>
              </div>
              <div className="bx-stat">
                <p className="bx-stat-label">Selisih</p>
                <p className="bx-stat-value">
                  {formatDot(sumMasuk + sumKeluar)}
                </p>
              </div>
            </div>

            <div className="bx-chart">
              <Chart
                options={templateData && templateData.options}
                series={templateData && templateData.series}
                type="bar"
                height={800}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default Box;
